/**
 * Verifica se a permissão de geolocalização já foi concedida
 * @returns {Promise<boolean>} true se a permissão já foi concedida, false caso contrário
 */
export async function checkGeolocationPermission() {
  try {
    // Tentar usar a API de Permissions se disponível
    if (navigator.permissions && navigator.permissions.query) {
      const result = await navigator.permissions.query({ name: 'geolocation' });
      console.log('[Permissions] Status da permissão de geolocalização:', result.state);
      return result.state === 'granted';
    }
    
    // Fallback: tentar obter a posição com timeout curto
    // Se conseguir, a permissão já foi concedida
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(false);
        return;
      }
      
      const timeoutId = setTimeout(() => {
        resolve(false);
      }, 1000);
      
      navigator.geolocation.getCurrentPosition(
        () => {
          clearTimeout(timeoutId);
          resolve(true);
        },
        () => {
          clearTimeout(timeoutId);
          resolve(false);
        },
        {
          enableHighAccuracy: false,
          timeout: 500,
          maximumAge: 0
        }
      );
    });
  } catch (error) {
    console.warn('[Permissions] Erro ao verificar permissão de geolocalização:', error);
    return false;
  }
}

/**
 * Verifica se a permissão de câmera já foi concedida
 * @returns {Promise<boolean>} true se a permissão já foi concedida, false caso contrário
 */
export async function checkCameraPermission() {
  try {
    // Tentar usar a API de Permissions se disponível
    if (navigator.permissions && navigator.permissions.query) {
      const result = await navigator.permissions.query({ name: 'camera' });
      console.log('[Permissions] Status da permissão de câmera:', result.state);
      return result.state === 'granted';
    }
    
    // Fallback: tentar acessar a câmera com timeout curto
    // Se conseguir, a permissão já foi concedida
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      return false;
    }
    
    try {
      const stream = await Promise.race([
        navigator.mediaDevices.getUserMedia({ video: true }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 500))
      ]);
      
      // Se conseguiu acessar, parar o stream e retornar true
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (error) {
      // Se o erro for de permissão negada, retornar false
      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        return false;
      }
      // Outros erros (timeout, dispositivo não encontrado, etc) também retornam false
      return false;
    }
  } catch (error) {
    console.warn('[Permissions] Erro ao verificar permissão de câmera:', error);
    return false;
  }
}

